(function () {
  const url = new URL(location.href);
  const params = url.searchParams;

  if (params.has('utm_campaign')) {
    // クーポンを表示する日数
    const displayedDaysNum = 7;

    const date = new Date();
    date.setDate(date.getDate() + displayedDaysNum);
    // 「YYYYMMDD」の形式にフォーマット
    const endDate =
      date.getFullYear() +
      (date.getMonth() + 1).toString().padStart(2, '0') +
      date.getDate().toString().padStart(2, '0');
    const setObject = {
      id: params.get('utm_campaign'),
      endDate: endDate,
    };
    localStorage.setItem('ad_group_utm_campaign', JSON.stringify(setObject));
  }
})();
